import { Component } from '@angular/core'
import { ICellRendererAngularComp } from 'ag-grid-angular'
import { Router } from '@angular/router'

import{ AcessoApiService } from '../../acessoApi.service'
import{ FinanceiroService } from './financeiro.service'


@Component({
  selector: 'btns-cell',
  template: `<button type="button" class="estilo-botao" (click)="Download()"><i class="fa fa-search fa-2x"></i></button>`, 
  styles: [
    `.estilo-botao {
        margin-right: 5px;
        border: none;
        background-color: white;
    }`
  ]
})
export class BotoesGridRender implements ICellRendererAngularComp{
    public params: any
    constructor(private rotas: Router, private acessoAPI: AcessoApiService, private acessoServico :FinanceiroService){}

    agInit(params: any): void {
        this.params = params;
    }

    public Download() {
         this.acessoServico.setCodBoleto(parseInt(`${this.params.data.ID_BLTO}`))
         this.rotas.navigate(['/financeiro/pdf'])
        
    }

    // public impressaoBoleto() {
    //     // this.acessoService.teste(`${this.params.data.ID_BLTO}`)

    // }

    refresh(): boolean {
        return false;
    }


}


// WEBPACK FOOTER //
// ./src/app/pages/financeiro/botoesGrid.component.ts